<template>
	<div class="apply-refund">
		<div class="tips">
			<div>请填写拒绝退款理由，方便用户查询！</div>
		</div>
		<div class="content">
			<van-form 
			 	:show-error-message="false" 
				validate-trigger="onSubmit" 
				validate-first
				ref="form"
			>
				<div class="card" @click="changeReason">
					<van-field 
						v-model="formData.offlineRefundTime" 
						label-width="8em" 
						is-link 
						readonly 
						placeholder="请选择线下退款时间"
						:rules="[{ required: true, message: '请选择线下退款时间' }]"
					>
						<template slot="label">
							<div class="label">
								<span class="asterisk">*</span>
								线下退款时间
							</div>
						</template>
					</van-field>
				</div>
				<div class="card">
					<div class="label">
						<span class="asterisk">*</span>
						线下退款凭证
						<span class="sub"> (请上传jpg,png格式图片，最多不超过6张)</span>
					</div>
					<van-field :rules="[{ required: true, message: '请上传补充图片凭证' }]">
						<template #input>
							<div class="upload-box">
								<van-uploader
									:max-count="6" 
									:before-read="beforeImgUpload" 
									:fileList="formData.fileList" 
									:after-read="uploadImg"
									@delete="deleteImg"
								/>
							</div>
						</template>
					</van-field>
				</div>
			</van-form>
		</div>
		<div style="height: 115px;"></div>
		<div class="footer">
			<div class="btn-box">
				<div class="btn-item secondary" @click="back">返回</div>
				<div class="btn-item" @click="submitVerify">提交</div>
			</div>
		</div>
		<van-popup v-model="showSheet" position="bottom" get-container="body">
			<van-datetime-picker
				v-model="currentDate"
				type="datetime"
				title="选择时间"
				:min-date="minDate"
				:max-date="maxDate"
				@confirm="changeTime"
				@cancel="cancelTime"
			/>
		</van-popup>
	
	</div>
</template>

<script>
import moment from 'moment'
export default {
	data() {
		return {
			minDate: new Date(2024, 0, 1),
      maxDate: new Date(2029, 10, 1),
      currentDate: new Date(),
			showSheet: false,
			formData: {
				offlineRefundTime: '',
				fileList: [],
			},
		}
	},
	methods: {
		changeReason() {
			this.showSheet = true
		},
		changeTime(e) {
			this.formData.offlineRefundTime = moment(e).format('YYYY-MM-DD HH:mm:ss')
			this.showSheet = false
		},
		cancelTime() {
			this.showSheet = false
		},
		beforeImgUpload(file) {
      const acceptTypes = ['image/png', 'image/jpeg', 'image/gif'];
      if (!acceptTypes.includes(file.type)) {
        this.$toast('请上传png、jpg或gif格式图片');
        return false;
      }
      return true;
    },
    uploadImg(file) {
      const currentFile = {
        url: '',
        status:'uploading',
        message: '上传中...'
      }
      this.formData.fileList.push(currentFile)
      this.$api.common.uploadImg(file.file)
        .then(({data}) => {
          if (data && data[0]) {
            const fileUrl = data[0].fileUrl;
            currentFile.url = fileUrl
            currentFile.status = 'done'
          }
        })
        .catch(err => {
          this.isUploadImg = false
          const currentIndex = this.formData.fileList.indexOf(currentFile);
          if (currentIndex > -1) {
            this.formData.fileList.splice(currentIndex, 1);
          }
      });
    },
    deleteImg(file) {
      const currentIndex = this.formData.fileList.indexOf(file);
      if (currentIndex > -1) {
        this.formData.fileList.splice(currentIndex, 1);
      }
    },
   
		submitVerify() {
			this.$refs.form.validate()
				.then(res => {
					this.submit()
				}).catch(err => {
					this.$toast(err[0].message);
				})
		},
    submit() {
			const { orderNo, number } = this.$route.query
			this.formData.orderNo = orderNo
			this.formData.offlineRefundProofPic = JSON.stringify(this.formData.fileList)
			this.$api.customerList.offlineRefund(this.formData)
				.then(res => {
					if (res.success) {
						this.$toast('提交成功');
						setTimeout(() => {
							this.$router.go(number)
						}, 2000);
					}
				})
		
    },
		back() {
			this.$router.go(-1)
    },
	}
}
</script>

<style lang="stylus" scoped>
	.apply-refund {
		height: 100vh;
		background: #F4F4F4;
		overflow-y: auto;
		.tips {
			width: 100%;
			height: 40px;
			color: #FF6B31;
			font-size: 15px;
			text-align: center;
			line-height: 40px;
			background: #FFF6F3;
		}
		.content {
			padding: 0 15px;
			.card {
				padding: 15px;
				margin-top: 12px;
				border-radius: 8px;
				background: #fff;
        >>> .van-cell {
          padding: 0;
        }
				.label {
          position: relative;
					color: #333333;
					font-size: 15px;
					font-weight: bold;
					padding-left: 6px;
          .asterisk {
            position: absolute;
            left: 0;
            top: 0;
            color: #FF6B31;
            font-size: 13px;
          }
					.sub {
						color: #999999;
						font-size: 13px;
						font-weight: 400;
					}
				}
				.text-box {
					border-radius: 8px;
					padding: 15px;
					margin-top: 15px;
					min-height: 85px;
					word-wrap: break-word;
					background: #F5F5F5;
					.backgd  {
						padding: 0;
						background: #F5F5F5;
					}
				}
				.upload-box {
          border-radius: 8px;
          margin: 15px 4px 0 4px
					.shade {
						display: flex;
						justify-content: center;
						align-items: center;
						width: 92px;
						height: 92px;
						border-radius: 8px;
						border: 1rpx dashed #BBBBBB;
						.img-icon {
							width: 44px;
							height: 44px;
						}
					}
				}
			}
		}
		.footer {
			position: fixed;
			bottom: 0;
			left: 0;
			right: 0;
			background: #F4F4F4;
			.btn-box {
				display: flex;
				justify-content: space-around;
				height: 84px;
				background: #fff;
				.btn-item {
					width: 138px;
					height: 43px;
					font-size: 17px;
					color: #fff;
					font-weight: 500;
					text-align: center;
					line-height: 43px;
					background: #FF6B31;
					border-radius: 8px;
					margin-top: 10px;
					border: 1px solid transparent;
				}
				.secondary {
					color: #FF6B31;
					border: 1px solid #FF6B31;
					background: #fff;
				}
			}
		}
		
	}
</style>